{
  "title": "Inventory counts",
  "subtitle": "Count what is really on the shelves; validation corrects the stock to match.",
  "status": {
    "draft": "Draft",
    "in_progress": "In progress",
    "review": "To review",
    "validated": "Validated",
    "cancelled": "Cancelled"
  },
  "kinds": {
    "location": {
      "title": "One location",
      "text": "Every product in a store, warehouse or zone"
    },
    "category": {
      "title": "One category",
      "text": "For example only Electrical, in one location"
    },
    "full": {
      "title": "Everything",
      "text": "A full count of all products, everywhere"
    }
  },
  "scope": {
    "everything": "Everything",
    "everywhere": "every location",
    "category": "category {{name}}",
    "started": "started {{when}} by {{name}}",
    "prepared": "prepared {{when}} by {{name}}"
  },
  "columns": {
    "number": "Number",
    "scope": "What is counted",
    "when": "When",
    "counted": "Counted",
    "different": "Differences",
    "status": "Status",
    "product": "Product",
    "expected": "Expected",
    "difference": "Difference",
    "value": "Value (TND)"
  },
  "list": {
    "status": "Status",
    "anyStatus": "Any status",
    "progress": "{{counted}} / {{total}}",
    "emptyTitle": "No count yet",
    "emptyText": "Start a count to compare the shelves with the system.",
    "loadMore": "Load more"
  },
  "sessions": {
    "title": "Count sessions",
    "all": "All",
    "none": "No count yet.",
    "this": "this count"
  },
  "start": {
    "title": "Start a new count",
    "question": "What do you want to count?",
    "dialogText": "Nothing is frozen yet: the products are frozen when you start counting.",
    "location": "Location",
    "category": "Category",
    "choose": "Choose…",
    "note": "Note (optional)",
    "cancel": "Cancel",
    "prepare": "Prepare the count"
  },
  "draft": {
    "title": "Ready to start",
    "text_one": "When you start, the system notes what it expects for {{count}} product and freezes it at {{place}} until the count is validated or cancelled.",
    "text_other": "When you start, the system notes what it expects for {{count}} products and freezes them at {{place}} until the count is validated or cancelled.",
    "start": "Start counting",
    "discard": "Discard",
    "discardTitle": "Discard this count?",
    "discardText": "Nothing was frozen. The count keeps its number and shows as Cancelled."
  },
  "detail": {
    "title": "Inventory count"
  },
  "counting": {
    "cancel": "Cancel count",
    "finish": "Finish and review",
    "frozen_one": "{{count}} product is frozen in {{place}}.",
    "frozen_other": "{{count}} products are frozen in {{place}}.",
    "progress": "{{counted}} of {{total}} counted",
    "differences_one": "{{count}} difference so far",
    "differences_other": "{{count}} differences so far",
    "scan": "Scan a product, then type how many you see",
    "filter": "Show",
    "emptyFilter": "Nothing here.",
    "now": "Now counting",
    "expects": "System expects",
    "counted": "counted",
    "minus": "One less",
    "plus": "One more",
    "saveNext": "Save and scan next",
    "found": "{{name}} is not in this count",
    "foundText": "The system did not expect it here. Add it and count it: what you count is what will be in stock.",
    "where": "Where",
    "add": "Add and count",
    "notNow": "Not now",
    "noMatch": "No product matches: check the code, or type more of the name.",
    "recount": "Recount",
    "expectedShort": "expected {{value}}",
    "notCounted": "not counted",
    "showing": "Showing {{shown}} of {{total}}",
    "footer": "counts are saved as you type · negative expected quantities are included so they get corrected",
    "cancelTitle": "Cancel this count?",
    "cancelText": "Nothing changes in stock. The products are free to move again.",
    "cancelled": "Count cancelled",
    "frozenText_one": "It cannot be received, issued or transferred there until this count is validated or cancelled, so the numbers stay correct.",
    "frozenText_other": "They cannot be received, issued or transferred there until this count is validated or cancelled, so the numbers stay correct.",
    "pickVariant": "{{name}} has variants: which one are you counting?",
    "noVariant": "This product has no active variant."
  },
  "filters": {
    "all": "All",
    "not_counted": "Not counted",
    "counted": "Counted",
    "different": "Different"
  },
  "finish": {
    "title_one": "{{count}} product is not counted yet",
    "title_other": "{{count}} products are not counted yet",
    "text": "Go back and count them, or count them as zero: the system then removes them from stock at validation.",
    "asZero": "Count them as zero and review"
  },
  "review": {
    "title": "Review the count",
    "export": "Export differences to Excel",
    "counted": "Products counted",
    "nothingLeft": "Nothing left to count",
    "left_one": "{{count}} left to count",
    "left_other": "{{count}} left to count",
    "matching": "Matching",
    "matchingHint": "Counted = expected",
    "different": "Different",
    "differentHint": "{{fewer}} fewer, {{more}} more than expected",
    "value": "Value difference",
    "share": "{{percent}}% of expected value · limit is {{limit}}%",
    "differ": "Products that differ",
    "onlyDifferences_one": "Only differences are shown · {{count}} product matched",
    "onlyDifferences_other": "Only differences are shown · {{count}} products matched",
    "allMatch": "Every product counted matches what the system expected.",
    "line": "expected {{expected}} · counted {{counted}}",
    "recount": "Recount",
    "more_one": "+ {{count}} more product",
    "more_other": "+ {{count}} more products",
    "showAll": "Show all",
    "total": "Total difference",
    "whenTitle": "When you validate",
    "when1_one": "{{count}} correction is created for you, with the reason “Count correction”.",
    "when1_other": "{{count}} corrections are created for you, with the reason “Count correction”.",
    "when2": "Stock at {{place}} becomes exactly what was counted.",
    "when3_one": "The {{count}} product is unfrozen and can move again.",
    "when3_other": "The {{count}} products are unfrozen and can move again.",
    "back": "Back to counting",
    "validate": "Validate count",
    "managerValidates": "A manager validates this count.",
    "done": "{{number}} validated: stock now matches the count",
    "validatedBy": "Validated {{when}} by {{name}}",
    "adjustment": "Corrections written in {{number}}",
    "noCorrection": "Everything matched: no correction was needed.",
    "cancelled": "This count was cancelled: stock did not change."
  }
}
